var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useController } from 'react-hook-form';
import { Select as InnerSelect } from '@myhealth-raccoon/components';
export var ControlledSelect = function (_a) {
    var name = _a.name, control = _a.control, rules = _a.rules, shouldUnregister = _a.shouldUnregister, defaultValue = _a.defaultValue, disabled = _a.disabled, selectProps = __rest(_a, ["name", "control", "rules", "shouldUnregister", "defaultValue", "disabled"]);
    var _b = useController({ name: name, control: control, rules: rules, shouldUnregister: shouldUnregister, defaultValue: defaultValue, disabled: disabled }).field, onChange = _b.onChange, value = _b.value, ref = _b.ref;
    return React.createElement(InnerSelect, __assign({ onChange: onChange, value: value, ref: ref, name: name }, selectProps));
};
